<template>
  <section class="notification__container">
      <div v-show="isLoading" class="spinner-container">
          <div class="spinner"></div>
      </div>
    <nav class="notification__header">
      <h2 class="notification__header__title">{{ title }}</h2>
      <div class="notification__header__right">
        <span
          v-if="doubleSwitchText"
          class="notification__header__switch__container"
        >
          <p v-show="!toggleValue" class="notification__header__switch__text" style="cursor: pointer"
            @click="toggleAll">{{ doubleSwitchText[0] }}</p>
          <ToogleSwitch
            v-model="toggleValue"
            @toggle-all="$emit('toggle-all')"
          />
          <p v-show="toggleValue" class="notification__header__switch__text" style="cursor: pointer"
            @click="toggleAll">{{ doubleSwitchText[1] }}</p>
          <span class="notification__header__switch__button"></span>
        </span>
        <i class="notification__header__close__btn fa fa-times" @click="close"></i>
      </div>
      <div @click="toggleOrder" class="notification__header__order__switch">
        <i :class="asc ? 'fas fa-sort-amount-up-alt' : 'fas fa-sort-amount-down-alt'"></i>
        <p> {{asc ? 'Ordem Crescente' : 'Ordem Decrescente'}}</p>
      </div>
    </nav>
    <div class="notification__cards__container" :class="!expanded ? 'active' : ''">
      <AtendimentoCard
        v-for="(card, index) in cards"
        @update-card="$emit('update-card', $event)"
        @openCard="$emit('openCard', $event)"
        @close-notification="$emit('close-notification')"
        :key="index"
        :card-icon="card.cardIcon"
        :card-icon-text="card.cardIconText"
        :card-person-pic="card.cardPersonPic"
        :card-title="card.cardTitle"
        :card-description="card.cardDescription"
        :card-checked="card.cardChecked"
        :card-obj="card.cardObj"
      />
      <div v-if="cards.length == 0" class="notification__card__empty">
        <p>Sem novas notificações!</p>
      </div>
    </div>
    <!-- <div v-if="viewedCards.length > 0" class="show__more" @click="toggle">
      <p>{{ expandText }}</p>
      <i :class="expanded ? 'fas fa-sort-up' : 'fa fa-sort-down'"></i>
    </div>-->
    <div class="notification__cards__container" :class="expanded ? 'active' : ''">
      <AtendimentoCard
        v-for="(viewedCard, index) in viewedCards"
        @update-card="$emit('update-card', $event)"
        @openCard="$emit('openCard', $event)"
        @close-notification="$emit('close-notification')"
        v-show="expanded"
        :key="index"
        :card-icon="viewedCard.cardIcon"
        :card-icon-text="viewedCard.cardIconText"
        :card-person-pic="viewedCard.cardPersonPic"
        :card-title="viewedCard.cardTitle"
        :card-description="viewedCard.cardDescription"
        :card-checked="viewedCard.cardChecked"
        :card-obj="viewedCard.cardObj"
      />
    </div>
  </section>
</template>

<script>
import AtendimentoCard from './AtendimentoCard.vue'
import ToogleSwitch from '../toogleSwitch/toogleSwitch.vue'

export default {
  name: 'DefaultNotificationAtendimento',
  props: {
    title: {
      type: String,
      required: true
    },
    expandText: {
      type: String,
      required: true
    },
    cards: {
      type: Array,
      default: () => []
    },
    viewedCards: {
      type: Array,
      default: () => []
    },
    notificationSwitch: {
      type: Boolean,
      default: false
    },
    doubleSwitchText: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      expanded: false,
      toggleValue: false,
      asc: true,
      isLoading: false // Adicionando o estado de carregamento
    }
  },
  watch: {
    viewedCards: function (newVal) {
      if (newVal.length === 0) {
        this.expanded = false
      }
    }
  },
  components: {
    AtendimentoCard,
    ToogleSwitch
  },
  methods: {
    close () {
      this.$emit('close-notification')
    },
    toggle () {
      this.expanded = !this.expanded
    },
    toggleOrder () {
      this.asc = !this.asc
      this.$emit('toggle-order')
    },
    toggleAll () {
      this.toggleValue = !this.toggleValue
      this.$emit('toggle-all')
    },
    startLoading () {
      this.isLoading = true
    },
    stopLoading () {
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss">
.notification {

  &__card__empty{
    background-color: #2F3136;
    width: 100%;
    border-radius: 4px;
    p{
      margin: 0 auto;
      padding: .5rem;
      text-align: center;
      text-transform: uppercase;
      color: #B8B9BA;
    }
  }

  &__container {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: .5rem;

    top: 0;
    right: 0;
    width: 30vw;
    min-width: 450px;
    max-height: 90vh;

    padding: 1rem .5rem;
    background: #2A2A2A;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;

    @media screen and (max-width: 500px) {
      min-width: 0;
      width: 99.6vw;
    }
  }

  &__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .75rem 1rem .75rem ;
    box-sizing: border-box;
    position: relative;

    &__order__switch{
      position: absolute;
      right: .75rem;
      bottom: -.25rem;

      display: flex;
      align-items: center;
      gap: .5rem;

      color: #d9d9d9;
      cursor: pointer;

      p{
        margin: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
    }

    &__right {
      display: flex;
      gap: 1.5rem;
    }

    &__title {
      font-weight: 400;
      font-size: 2rem;
      line-height: auto;

      letter-spacing: -0.04em;
      margin: 0;
      color: #FFFFFF;
    }

    &__close__btn{
      cursor: pointer;
    }

    &__switch {

      &__container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: .5rem;
        flex-direction: row-reverse;
      }

      &__text {
        font-weight: 400;
        font-size: 1rem;
        line-height: auto;
        letter-spacing: -0.04em;
        color: #FFFFFF;
        margin: 0;
      }
    }

    &__close__btn {
      font-size: 1.5rem;
      color: #FFFFFF;
      margin: 0;
    }

  }

  &__cards__container{
    width: 100%;
    display: none;
    flex-direction: column;
    gap: .5rem;
    height: fit-content;
    overflow-y: scroll;

    max-height: 10rem;

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    &.active{
      display:flex;
      max-height: 90vh !important;
    }
  }

}

.show__more {
  width: 100%;
  padding: 1rem 0;

  display: flex;
  justify-content: center;
  align-content: center;
  gap: .5rem;

  background-color: #04A791;
  border-radius: 4px;

  p {
    font-size: 1rem;
    line-height: 100%;
    letter-spacing: -0.02em;
    text-transform: uppercase;
    color: #FFFFFF;

    margin: 0;
  }

  i {
    color: #FFFFFF;
    margin: 0;
  }
}
.spinner-container {
display: flex;
justify-content: center;
align-items: center;
height: 100vh;
}

.spinner {
border: 4px solid rgba(0, 0, 0, 0.1);
border-left: 4px solid #1BACA0;
border-radius: 50%;
width: 40px;
height: 40px;
animation: spin 1s linear infinite;
}

@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/notificacao/NotificacaoAtendimentoPadrao.vue